export default __webpack_public_path__ + "static/media/banner.30b43198.jfif";